import { RouterProvider } from 'react-router-dom'
import { ApolloProvider } from '@apollo/client'
import UnavailabilityAlert from './components/Common/UnavailabilityAlert'
import apolloClient from './config/apolloClient'
import './App.css'
import { CurrentUserProvider } from './components/User/UserProvider'
import { CurrentHcsProvider } from './components/feature/hcs/CurrentHcsProvider/CurrentHcsProvider'
import mainRouter from './routers/routers/mainRouter'
import externalRouter from './routers/routers/externalRouter'

const App = () => {
    const {
        location: { pathname },
    } = window

    const isExternal = pathname.includes('/ext')

    if (isExternal)
        return (
            <ApolloProvider client={apolloClient}>
                <CurrentUserProvider>
                    <CurrentHcsProvider>
                        <RouterProvider router={externalRouter} />
                        <UnavailabilityAlert />
                    </CurrentHcsProvider>
                </CurrentUserProvider>
            </ApolloProvider>
        )

    return (
        <ApolloProvider client={apolloClient}>
            <RouterProvider router={mainRouter} />
        </ApolloProvider>
    )
}

export default App
